const TIMEZONE = 'en-GB';

export const formatDate = (timestamp: number) => {
  const date = new Date(timestamp);

  // Format the date to get the day of the week and the date in the desired format
  const dayOfWeek = new Intl.DateTimeFormat('TIMEZONE', {
    weekday: 'short',
  }).format(date);
  const day = date.getDate();
  const month = new Intl.DateTimeFormat(TIMEZONE, { month: 'short' }).format(
    date
  );
  const year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
  const time = new Intl.DateTimeFormat(TIMEZONE, {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(date);

  // Combine all parts into the final string
  return `${dayOfWeek} ${day} ${month} ${year} ${time}`;
};
